import type { EconomicEvent } from "./types";

/** Triple aligned with catalog / UI: impact|currency|event name */
export function seriesKey(event: EconomicEvent): string {
  return `${event.impact}|${event.currency}|${event.name}`;
}

export function matchesSeries(event: EconomicEvent, key: string): boolean {
  return seriesKey(event) === key;
}

/** Chronological order (oldest first) */
export function filterEventsBySeriesKey(
  allEvents: readonly EconomicEvent[],
  key: string
): EconomicEvent[] {
  return [...allEvents]
    .filter((e) => matchesSeries(e, key))
    .sort(
      (a, b) =>
        new Date(a.dateTimeISO).getTime() -
        new Date(b.dateTimeISO).getTime()
    );
}
